/**
 * Valida um NIF português (9 dígitos, algoritmo do dígito de controlo).
 * @param {string} nif - NIF a validar (aceita com ou sem formatação)
 * @returns {boolean} - true se o NIF for válido
 */
export const validateNIF = (nif) => {
  nif = nif.replace(/\D/g, '');

  if (!/^\d{9}$/.test(nif)) return false;

  const firstDigit = parseInt(nif.charAt(0));

  if ([0].includes(firstDigit)) return false;

  let total = 0;
  for (let i = 0; i < 8; i++) {
    total += parseInt(nif.charAt(i)) * (9 - i);
  }

  let checkDigit = 11 - (total % 11);
  if (checkDigit >= 10) checkDigit = 0;

  return checkDigit === parseInt(nif.charAt(8));
};
